import { Theme, useMediaQuery, useTheme } from "@material-ui/core";
import { useMemo } from "react";
import { useAtomicStyles } from "styles";
import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputHelper: {
      marginTop: "1em",
      marginLeft: "1em",
    },
    label: {
      color: "black",
    },
    uploaderMobile: {
      [theme.breakpoints.down("xs")]: {
        minHeight: `120px !important`,
        maxHeight: `150px !important`,
      },
    },
    inn: {
      margin: "20px",
    },
  }),
);

const useUploadFile = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(
    () => ({
      rootMobile: {
        root: styles.uploaderMobile,
      },
    }),
    [styles],
  );
  const atomicStyles = useAtomicStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return {
    styles,
    atomicStyles,
    classes,
    isMobile,
  };
};

export default useUploadFile;
